import React from "react";
import SuperAdminHomePage from "./SuperAdminHomePage"

const AdminHomePage = () => {
    return (
        <SuperAdminHomePage />
    );
};

export default AdminHomePage;
